import React, { useState, useRef, useEffect } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import kumarAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import TypingDots from '../Components/TypingDots';
import { callOpenAI } from '../utils/openaiService';

const startupIdeas = [
  {
    industry: 'AgriTech',
    growth: 'India’s agri-tech market expected to reach $24B by 2025',
    idea: 'A WhatsApp bot that helps small farmers track weather & market prices',
  },
  {
    industry: 'Creator Tools',
    growth: 'Global creator economy is booming with over 80M+ creators',
    idea: 'A tool that turns voice notes into scripts & AI-generated visuals',
  },
  {
    industry: 'Logistics / EV Fleet',
    growth: 'India’s last-mile EV delivery market growing 14% YoY',
    idea: 'A dashboard that helps kirana shops adopt EV delivery services',
  },
  {
    industry: 'Mental Wellness',
    growth: 'Demand for anonymous therapy & Gen Z peer support apps rising',
    idea: 'A journaling app with mood tracking + safe vent space',
  },
];

const StartupPage = () => {
  const chatRef = useRef(null);
  const [chatMessages, setChatMessages] = useState([
    {
      sender: 'ai',
      avatar: kumarAvatar,
      name: 'Kumar',
      message: `Let’s find startup sectors that match your vibe. No pressure… 😌

You can either select a card below or type your own startup idea or industry, and I’ll help guide you through it. Let’s go 🚀`,
      timestamp: new Date().toLocaleString(),
    },
  ]);
  const [isThinking, setIsThinking] = useState(false);
  const [showCards, setShowCards] = useState(true);

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [chatMessages, isThinking]);

  const formatMessages = (msgs) =>
    msgs.map((m) => ({
      role: m.sender === 'ai' ? 'assistant' : 'user',
      content: m.message,
    }));

  const sendMessageToAI = async (text) => {
    setIsThinking(true);

    const newUserMessage = {
      sender: 'user',
      avatar: userAvatar,
      name: 'You',
      message: text,
      timestamp: new Date().toLocaleString(),
    };

    const updatedMessages = [...chatMessages, newUserMessage];
    setChatMessages(updatedMessages);
    setShowCards(false);

    const reply = await callOpenAI({
      messages: [...formatMessages(updatedMessages)],
      screenContext: 'startup',
    });

    setChatMessages((prev) => [
      ...prev,
      {
        sender: 'ai',
        avatar: kumarAvatar,
        name: 'Kumar',
        message: reply,
        timestamp: new Date().toLocaleString(),
      },
    ]);
    setIsThinking(false);
  };

  const handleSend = (text) => {
    if (text.trim()) sendMessageToAI(text);
  };

  const handleCardClick = (industry) => {
    sendMessageToAI(`Tell me more about startup ideas in the "${industry}" space.`);
  };

  return (
    <div className="w-full max-w-[1000px] mx-auto p-6 flex flex-col bg-white/80 rounded-[30px] shadow-xl backdrop-blur-md h-[85vh] overflow-hidden">
      <div className="flex flex-col gap-6 overflow-y-auto flex-grow pr-2 custom-scroll" ref={chatRef}>
        {chatMessages.map((msg, i) => (
          <ChatBubble key={i} {...msg} />
        ))}

        {isThinking && (
          <ChatBubble
            sender="ai"
            avatar={kumarAvatar}
            name="Kumar"
            message={<TypingDots />}
          />
        )}

        {showCards && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {startupIdeas.map((item, idx) => (
              <div
                key={idx}
                className="bg-white rounded-2xl p-5 shadow-md flex flex-col justify-between border border-stone-200"
              >
                <div className="space-y-2">
                  <h3 className="font-bold text-lg font-sora text-orange-900">
                    🚀 Industry: {item.industry}
                  </h3>
                  <p className="text-sm text-stone-700 font-medium">
                    📊 <strong>Growth:</strong> {item.growth}
                  </p>
                  <p className="text-sm text-stone-700 font-medium">
                    💡 <strong>Idea:</strong> {item.idea}
                  </p>
                </div>

                <button
                  onClick={() => handleCardClick(item.industry)}
                  className="mt-5 w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 rounded-xl transition-all"
                >
                  Explore Startup Idea
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-6 shrink-0">
        <MessageInput onSend={handleSend} />
      </div>
    </div>
  );
};

export default StartupPage;
